var render = function render(){var _vm=this,_c=_vm._self._c;return _c('quill-editor',{ref:"myQuillEditor",style:({height: _vm.height + 'px'}),attrs:{"content":_vm.value,"options":_vm.editorOption},on:{"blur":_vm.blur,"change":_vm.getHTML}})
}
var staticRenderFns = []

export { render, staticRenderFns }